import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Button, Icon } from 'loyal-react'
import { Link } from 'react-router-dom'
import { Title, ProductShipping, TrackingItem, availableVendors } from './'

import { ProductImage } from 'features/ProductImage'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

import 'react-placeholder/lib/reactPlaceholder.css'

import ReactPlaceholder from 'react-placeholder'
import TrackingItemPlaceholder from './TrackingItemPlaceholder'

const voucherName = 'DSHOP'

const getVoucherLink = props => {
  let model = {
    OrderId: props.orderDetail.orderId,
    CatalogId: props.orderDetail.catalogId,
    VendorId: props.orderDetail.vendorId,
    ClientId: props.orderDetail.clientId
  }
  props.handleVoucherLink(model)
}

const ProductSide = props => {
  let decimalValue =
    props &&
    props.parentOrderDetail &&
    props.parentOrderDetail.orderPaymentDetailMoneyAndPoints &&
    props.parentOrderDetail.orderPaymentDetailMoneyAndPoints
      .purchaseValueDecimal
  let pointsUsedDecimal =
    props.parentOrderDetail.orderPaymentDetailMoneyAndPoints &&
    props.parentOrderDetail.orderPaymentDetailMoneyAndPoints.pointsUsedDecimal

  let storeDescription =
    props.storeConfiguration &&
    props.storeConfiguration.description &&
    props.storeConfiguration.description.toUpperCase()
  let storeName = props.parentOrderDetail.vendorOrderModel[0].vendorName.toUpperCase()
  let unitValue = null

  let donationValue = props &&
  props.productDetail &&
  props.productDetail.currencySellingPrice

  if (
    props.parentOrderDetail.vendorOrderModel[0].vendorName ===
    'Compra de Pontos'
  ) {
    unitValue = (
      <div className='col-12 txt-body-sm txt-font-body color-ui-2'>
        Valor: <strong>R$ {addZeroes(decimalValue)}</strong>
      </div>
    )
  } else if (props.parentOrderDetail.paymentType === 5) {
    unitValue = (
      <div className='col-12 txt-body-sm txt-font-body color-ui-2'>
        Valor unitário: <strong>R$ {addZeroes(decimalValue)}</strong>
      </div>
    )
  } else if (props.orderDetail.vendorType === 'Doação') {
    unitValue = (

      <div className='col-12 txt-body-sm txt-font-body color-ui-2'>
        Valor em reales:{' '}
        <CatalogCurrencyLabel
          value={
            pointsUsedDecimal !== props.productDetail.sellingPrice &&
              pointsUsedDecimal !== 0
              ? pointsUsedDecimal
              : props.productDetail.sellingPrice
          }
        />
        {props && props.productDetail && props.productDetail.currencySellingPrice
          ? <p className='txt-body-sm txt-font-body color-ui-2'>Valor: R$ {addZeroes(donationValue)}</p>
          : ''}
      </div>
    )
  } else {
    unitValue = (
      <div className='col-12 txt-body-sm txt-font-body color-ui-2'>
        Valor{ (props.orderDetail.vendorType !== 'Milhas') && ' unitário' }:{' '}
        <CatalogCurrencyLabel
          value={
            pointsUsedDecimal !== props.productDetail.sellingPrice &&
            pointsUsedDecimal !== 0
              ? pointsUsedDecimal
              : props.productDetail.sellingPrice
          }
        />
        {props.parentOrderDetail.orderPaymentDetailMoneyAndPoints
          .purchaseValueDecimal !== 0 &&
        props.parentOrderDetail.paymentType === 2
          ? ` + R$ ${addZeroes(
            props.parentOrderDetail.orderPaymentDetailMoneyAndPoints
              .purchaseValueDecimal
          )}`
          : ''}
      </div>
    )
  }
  return (
    <div className='cart-side col-12 col-md-8 px-0 pl-md-1 pr-md-2'>
      <div className='border-ui-3 radius bg-white'>
        <Title orderId={props.parentOrderDetail.parentOrderId} />
        <div className='cart-products col-12 mx-0'>
          <div className='cart-item row px-2 border-color-ui-3 border-bottom py-2'>
            <div className='cart-img col-auto txt-center pl-1 pt-1 pb-1 pr-2'>
              <ProductImage
                name={props.productDetail.name}
                alt={props.productDetail.name}
                imageUrl={props.productDetail.imageUrl}
                vendorId={props.orderDetail.vendorId}
                vendorType={props.orderDetail.vendorType}
                ready
              />
            </div>
            <div className='cart-product-info col'>
              <div className='cart-product-info row'>
                <div className='product-infos col-12 mx-0'>
                  <h2 className='txt-body-sm txt-font-body color-ui-2 '>
                    {props.productDetail.name}
                  </h2>
                </div>
              </div>
              <div className='row card-price-item  mt-1'>
                <div className='col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
                  {props.orderDetail.vendorType === 'Compra de Pontos' ? (
                    <span className='d-block'>
                      Quantidade:{' '}
                      <CatalogCurrencyLabel
                        value={props.productDetail.quantity * props.packageSize}
                      />
                    </span>
                  ) : (props.orderDetail.vendorType !== 'Milhas' && props.orderDetail.vendorType !== 'Doação') && (
                    <span>
                      Quantidade:{' '}
                      <strong>{props.productDetail.quantity}</strong>
                    </span>
                  )}
                </div>

                {unitValue}
                {props.productDetail.deliveryForecastParticipant ? (
                  <div className='col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
                    Previsão de entrega:{' '}
                    <strong>
                      {moment
                        .utc(props.productDetail.deliveryForecastParticipant)
                        .format('DD/MM/YYYY')}
                    </strong>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </div>
        {props.orderDetail.trackingVtexData ? (
          <div
            className={`row mx-0 px-3 border-color-ui-3 border-bottom py-2 d-print-none ${
              !props.productDetail.tracking ? 'd-none' : ''
            } `}
          >
            <ProductShipping
              trackingVtexData={props.orderDetail.trackingVtexData}
            />
          </div>
        ) : availableVendors.includes(props.orderDetail.vendorId) &&
          props.tracking ? (
          // eslint-disable-next-line react/jsx-indent
            <div
              className={`row mx-0 px-3 border-color-ui-3 border-bottom py-2 ${
                !props.productDetail.tracking ? 'd-none' : ''
              } `}
            >
              <ReactPlaceholder
                ready={!!props.tracking}
                customPlaceholder={<TrackingItemPlaceholder />}
              >
                <div className='row py-1 px-0'>
                  <TrackingItem tracking={props.tracking} />
                </div>
              </ReactPlaceholder>
            </div>
          ) : props.orderDetail.vendorType === 'e-Commerce' ? (
            <div className={`row mx-0 px-3 border-color-ui-3 border-bottom py-2`}>
              <ReactPlaceholder
                ready={props.showPlaceholder}
                customPlaceholder={<TrackingItemPlaceholder />}
              >
                <div className='row py-1 px-0'>
                  <TrackingItem
                    tracking={
                      props.orderDetail.vendorType === 'e-Commerce' &&
                    props.orderDetail.items.length > 0 &&
                    props.trackingAlternative
                    }
                  />
                </div>
              </ReactPlaceholder>
            </div>
          ) : (
            ''
          )}
        <div className='row mx-0 px-0 border-color-ui-3 border-bottom'>
          {storeName.includes(voucherName) ||
          (storeDescription && storeDescription.includes(voucherName)) ? (
            // eslint-disable-next-line react/jsx-indent
              <div className='row col-12 mx-0 px-3 bg-ui-5 border-color-ui-3 border-top border-bottom py-2'>
                <div className='row mx-0 col-12 col-md-9 align-items-center'>
                  <p className='txt-body-sm'>
                    <strong>
                    Consulte para saber mais sobre o envio do seu cupom.
                    </strong>
                  </p>
                </div>
                <div className='row mx-0 col-12 col-md-3'>
                  <Button
                    className='btn btn-featured btn-cart'
                    text='Consultar'
                    onClick={() => getVoucherLink(props)}
                  />
                </div>
              </div>
            ) : (
              ''
            )}
          <div className='d-none d-md-block row col-12 py-1 px-2 d-print-none'>
            <div className='cart-back px-0 txt-left'>
              <Link to={props.previousRoute || '/my-orders/'} className='btn btn-sm btn-flat btn-icon txt-left'>
                <Icon
                  iconName='icon_left'
                  className='icon icon-smr'
                />
                Ver todos os pedidos
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function addZeroes (value) {
  let newValue = value * 1
  newValue = newValue + ''

  let pos = newValue.indexOf('.')
  if (pos === -1) newValue = newValue + '.00'
  else {
    var integer = newValue.substring(0, pos)
    var decimals = newValue.substring(pos + 1)
    while (decimals.length < 2) decimals = decimals + '0'
    newValue = integer + ',' + decimals
  }
  return newValue.toString().replace('.', ',')
}

ProductSide.propTypes = {
  productDetail: PropTypes.object,
  parentOrderDetail: PropTypes.object,
  orderDetail: PropTypes.object,
  previousRoute: PropTypes.string,
  tracking: PropTypes.object,
  showPlaceholder: PropTypes.bool,
  storeConfiguration: PropTypes.object,
  trackingAlternative: PropTypes.object,
  packageSize: PropTypes.number
}

export default ProductSide



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderDetail/ProductSide/ProductSide.js